import { render } from "./MonitorsForm.vue?vue&type=template&id=d4670e7c"
import script from "./MonitorsForm.vue?vue&type=script&lang=js"
export * from "./MonitorsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__